import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  cursor: pointer;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { verizonTheme as theme } from '@vds-core/theme';
var propTypes = {
  /**
   * Content in the dropdown item.
   */
  children: PropTypes.string,

  /**
   * Function run when option is selected.
   */
  onSelect: PropTypes.func,

  /**
   * The id for the selected item.
   */
  selected: PropTypes.string,

  /**
   * ignore
   */
  id: PropTypes.string,

  /**
   * ignore
   */
  selectionCallback: PropTypes.func
};
var defaultProps = {
  children: null,
  onSelect: function onSelect() {},
  selected: undefined
};
var Wrapper = /*#__PURE__*/styled.li.withConfig({
  displayName: "Wrapper",
  componentId: "ll4m1m-0"
})(_templateObject());

var DropdownMarketingOption = function DropdownMarketingOption(_ref) {
  var children = _ref.children,
      onSelect = _ref.onSelect,
      selected = _ref.selected,
      id = _ref.id,
      selectionCallback = _ref.selectionCallback;

  function _clicked(e) {
    // Manually construct event here =>
    // because changing to a-tag doesn't pass the same event
    var event = {
      target: {
        value: children
      }
    };
    onSelect(event);
    selectionCallback(event);

    if (e.type === 'click' && e.clientX !== 0 && e.clientY !== 0) {
      // This is a real click. Do something here
      e.target.blur();
    }
  }

  function _onKeyDown(e) {
    var event = {
      target: {
        value: children
      }
    };

    if (e.keyCode === 13 || e.keyCode === 32) {
      onSelect(event);
      selectionCallback(event);
    }
  }

  return /*#__PURE__*/React.createElement(Wrapper, {
    tabIndex: 0,
    onKeyDown: _onKeyDown,
    id: id,
    value: children,
    onClick: _clicked,
    role: "none"
  }, children);
};

DropdownMarketingOption.defaultProps = defaultProps;
DropdownMarketingOption.propTypes = propTypes;
export default DropdownMarketingOption;